import React, { useState, useContext, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import "../styles/CrosstabModal.css";
import { FaTable } from "react-icons/fa";
import VariableContext from "../../contexts/VariableContext";
import FetchingFreq from "../../contexts/FetchingFreq";
import { useToast } from "../../contexts/ToastContext";
import config from "../../../src/configs/config";
import TabComp from "../TabComp";

export default function CrosstabModal({
  selectedVars,
  onClose,
  onGenerate,
  crosstabDisplayData,
  setCrosstabDisplayData,
}) {
  const {
    dataGroup,
    setdataGroup,
    selectedVariables,
    banners,
    setBanners,
    setSelectedVariables,
    projectId,
    savedWeightings,
    saveCurrentWeighting,
    currentSelectedVariablesset,
    setcurrentSelectedVariablesset,
    setSavedWeightings,
    weightedCounts,
    weightingStats,
    setWeightingStats,
    setWeightedCounts,
    targetPercentages,
    setTargetPercentages,
    currentSelectedVariables,
    setCurrentSelectedVariables,
    frequencyData,
    setFrequencyData,
    setSelectedClient,
    setSelectedProject,
    selectedProject,
    selectedClient,
    powner,
  } = useContext(VariableContext);

  const {
    setMessage,
    setActivePage,
    handleTitleClick,
    selectedTitle,
    setSelectedTitle,
    refreshData,
    setRefreshData,
    selectedBanner,
    setselectedBanner,
    selectedWeights,
    setSelectedWeights,
    selectedVariable,
    setSelectedVariable,
    isPropertiesShow,
    setIsPropertiesShow,
    handleSelectionChange,
    setSelectedBannerIndex,
  } = useContext(FetchingFreq);

  const { toast } = useToast();
  const [availableVars, setAvailableVars] = useState([]);
  const [rowVars, setRowVars] = useState([]);
  const [colVars, setColVars] = useState([]);
  const [confirmNest, setConfirmNest] = useState(null);
  const [hoveredVar, setHoveredVar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showBuilder, setShowBuilder] = useState(true);
  const [searchVar, setSearchVar] = useState("");

  useEffect(() => {
    setAvailableVars(selectedVars || []);
  }, [selectedVars]);

  const filteredAvailableVars = availableVars.filter((v) =>
    v.toLowerCase().includes(searchVar.toLowerCase())
  );

  const addVarToTree = (tree, varId, parentId = null) => {
    if (!parentId) return [...tree, { id: varId, children: [] }];
    return tree.map((node) => {
      if (node.id === parentId) {
        return {
          ...node,
          children: [...node.children, { id: varId, children: [] }],
        };
      } else if (node.children.length > 0) {
        return {
          ...node,
          children: addVarToTree(node.children, varId, parentId),
        };
      }
      return node;
    });
  };

  const removeVarFromTree = (tree, varId) => {
    return tree
      .filter((node) => node.id !== varId)
      .map((node) => ({
        ...node,
        children: removeVarFromTree(node.children, varId),
      }));
  };

  const flattenTreeForDraggable = (tree) => {
    let result = [];
    const flatten = (nodes) => {
      nodes.forEach((node) => {
        result.push(node.id);
        if (node.children.length > 0) flatten(node.children);
      });
    };
    flatten(tree);
    return result;
  };

  const getAlphabeticIdentifier = (index) => {
    let identifier = "";
    while (index >= 0) {
      identifier = String.fromCharCode((index % 26) + 65) + identifier;
      index = Math.floor(index / 26) - 1;
    }
    return identifier;
  };

  // Convert tree structure to banner rows format
  const convertTreeToBannerRows = (tree, varName) => {
    const payload = dataGroup[varName];
    if (!payload) return [];

    const rows = [];
    let index = 0;

    if (payload.type === "SingleResponse") {
      const valueLabels = payload.valueLabels;
      Object.keys(valueLabels).forEach((key) => {
        rows.push({
          headerText: varName,
          text: valueLabels[key],
          letter: getAlphabeticIdentifier(index),
          logic: `${varName}=${key}`,
        });
        index++;
      });

      if (payload.Nets) {
        payload.Nets.forEach((net) => {
          const netIndices = net.indices.join(",");
          rows.push({
            headerText: varName,
            text: `NET - ${net.label}`,
            letter: getAlphabeticIdentifier(index),
            logic: `${varName} in (${netIndices})`,
          });
          index++;
        });
      }
    } else if (payload.type === "Multiple2DGrid") {
      const subVariables = payload.Rows;
      const subVarNames = payload.varName;

      subVariables.forEach((subVar) => {
        const logicVar = subVarNames.find((x) => x.row === subVar.index);
        rows.push({
          headerText: varName,
          text: subVar.title,
          letter: getAlphabeticIdentifier(index),
          logic: `${logicVar?.Name}=1`,
        });
        index++;
      });

      if (payload.Nets) {
        payload.Nets.forEach((net) => {
          const netVar = subVarNames
            .filter((x) => net.indices.includes(x.row))
            .map((x) => `${x.Name}=1`);
          const netLogic = netVar.join(" or ");
          rows.push({
            headerText: varName,
            text: `NET - ${net.label}`,
            letter: getAlphabeticIdentifier(index),
            logic: netLogic,
          });
          index++;
        });
      }
    }

    return rows;
  };

  const renderTree = (tree, removeFn, droppableId, level = 0) => {
    return tree.map((node, index) => (
      <Draggable key={node.id} draggableId={node.id} index={index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              marginLeft: level * 20,
              position: "relative",
              ...provided.draggableProps.style,
            }}
            onMouseEnter={() => setHoveredVar(node.id)}
            onMouseLeave={() => setHoveredVar(null)}
          >
            <div
              className={`selected-pill ${
                removeFn === removeRowVar ? "blue" : "green"
              }`}
            >
              {node.id}{" "}
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  removeFn(node.id);
                }}
              >
                ×
              </span>
            </div>
            {hoveredVar === node.id && !snapshot.isDragging && (
              <div className="nest-hint">
                <span className="hint-icon">↓</span>
                <span className="hint-text">Drop here to nest</span>
              </div>
            )}
            {node.children.length > 0 &&
              renderTree(node.children, removeFn, droppableId, level + 1)}
          </div>
        )}
      </Draggable>
    ));
  };

  const removeRowVar = (v) => {
    setRowVars((prev) => removeVarFromTree(prev, v));
    setAvailableVars((prev) => [...prev, v]);
  };

  const removeColVar = (v) => {
    setColVars((prev) => removeVarFromTree(prev, v));
    setAvailableVars((prev) => [...prev, v]);
  };

  const handleConfirm = (action) => {
    const { parentId, childId, type } = confirmNest;
    if (action === "nest") {
      if (type === "row")
        setRowVars((prev) => addVarToTree(prev, childId, parentId));
      else setColVars((prev) => addVarToTree(prev, childId, parentId));
    } else if (action === "add") {
      if (type === "row") setRowVars((prev) => addVarToTree(prev, childId));
      else setColVars((prev) => addVarToTree(prev, childId));
    }
    // setAvailableVars(prev => prev.filter(v => v !== childId));
    setConfirmNest(null);
  };

  const onDragEnd = (result) => {
    const { destination, draggableId, combine } = result;

    if (!destination && !combine) return;

    let type = "row";
    if (combine) {
      const isInRow = flattenTreeForDraggable(rowVars).includes(
        combine.draggableId
      );
      const isInCol = flattenTreeForDraggable(colVars).includes(
        combine.draggableId
      );
      type = isInRow ? "row" : "col";
    } else if (destination) {
      type = destination.droppableId === "row-box" ? "row" : "col";
    }

    if (combine) {
      setConfirmNest({
        parentId: combine.draggableId,
        childId: draggableId,
        type,
      });
      return;
    }

    if (destination?.droppableId === "row-box") {
      // Check if there are already variables in row
      if (rowVars.length > 0) {
        setConfirmNest({
          parentId: rowVars[rowVars.length - 1].id,
          childId: draggableId,
          type: "row",
        });
      } else {
        setRowVars((prev) => addVarToTree(prev, draggableId));
        // setAvailableVars(prev => prev.filter(v => v !== draggableId));
        setSelectedTitle(draggableId);
      }
    } else if (destination?.droppableId === "col-box") {
      if (colVars.length > 0) {
        setConfirmNest({
          parentId: colVars[colVars.length - 1].id,
          childId: draggableId,
          type: "col",
        });
        handleSelectionChange(draggableId, dataGroup[draggableId]);
        setselectedBanner(banners[banners.length - 1]);
        setSelectedBannerIndex(banners.length - 1);
      } else {
        setColVars((prev) => addVarToTree(prev, draggableId));
        // setAvailableVars(prev => prev.filter(v => v !== draggableId));
      }
    }

    document.getElementById("row-box").style.borderColor = "#cbd5e1";
    document.getElementById("col-box").style.borderColor = "#cbd5e1";
  };

  const fetchCrosstabData = async (rowVarName, colVarName) => {
    try {
      // console.log (`🔍 Fetching crosstab data for Row: ${rowVarName}, Col: ${colVarName}`);

      const rowPayload = dataGroup[rowVarName];
      const colPayload = dataGroup[colVarName];

      if (!rowPayload || !colPayload) {
        console.error(
          `❌ Variable not found - Row: ${rowVarName}, Col: ${colVarName}`
        );
        return null;
      }

      // Create banner rows and columns from the variables
      const bannerRows = convertTreeToBannerRows(rowVars, rowVarName);
      const bannerCols = convertTreeToBannerRows(colVars, colVarName);

      const banner = {
        name: `${colVarName}`,
        rows: [
          {
            headerText: "Total",
            text: "Total",
            letter: "A",
            logic: "ALL",
          },
          ...bannerCols, // baaki rows baad me
        ],
        minbase: "",
        lowbase: "",
        minbaseSymbol: "**",
        lowbaseSymbol: "*",
        isCompliment: false,
      };

      // console.log (`📦 Banner object:`, banner);

      const requestBody = {
        varNames: rowPayload,
        projectId: projectId,
        selectedBanner: banner, // Now sending banner with both rows and columns
        selectedWeights: [],
      };

      // console.log (`🚀 Request body:`, requestBody);

      const response = await fetch(
        `${config.API_BASE_URL}/Dashboardfrequency`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      // console.log (`📡 Response status:`, response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`❌ Error response:`, errorText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      // console.log (`✅ Data received:`, data);
      return data;
    } catch (error) {
      console.error(`❌ Error fetching crosstab data:`, error);
      throw error;
    }
  };

  const handleGenerate = async () => {
    setLoading(true);

    try {
      const flatRowVars = flattenTreeForDraggable(rowVars);
      const flatColVars = flattenTreeForDraggable(colVars);

      const crosstabDataPromises = [];

      for (const rowVar of flatRowVars) {
        for (const colVar of flatColVars) {
          crosstabDataPromises.push(
            fetchCrosstabData(rowVar, colVar).then((data) => ({
              rowVar,
              colVar,
              data,
            }))
          );
        }
      }

      const crosstabResults = await Promise.all(crosstabDataPromises);

      const finalData = {
        crosstabData: crosstabResults,
        rowVars: flatRowVars,
        colVars: flatColVars,
        rowTree: rowVars,
        colTree: colVars,
      };

      // 🔥🔥🔥 THIS IS WHAT YOU WANT
      setCrosstabDisplayData(finalData);

      // Optional: still inform parent
      onGenerate?.(finalData);
    } catch (error) {
      console.error("❌ Error generating crosstab:", error);
      toast.error(error.message || "Error generating crosstab.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setActivePage("crosstabmodel");
  }, []);

  return (
    <div className="crosstab-page">
      <div className="crosstab-container">
        {/* ================= HEADER ================= */}
        {/* <div className="modal-header"> */}
        {/* <FaTable className="modal-icon" />
                    <div>
                        <h2>Create Crosstab</h2>
                        <p>Drag variables to define your analysis</p>
                    </div> */}

        {/* {crosstabDisplayData && (
                        <button
                            className="toggle-builder-btn"
                            onClick={() => setShowBuilder(prev => !prev)}
                        >
                            {showBuilder ? "📊 View Result" : "🛠 Edit Crosstab"}
                        </button>
                    )} */}

        {/* HEADER BUTTON */}
        {(!showBuilder || crosstabDisplayData) && (
          <button
            className="toggle-builder-btn"
            onClick={() => setShowBuilder((prev) => !prev)}
          >
            {showBuilder ? "Hide Crosstab" : "Show Crosstab"}
          </button>
        )}

        {/* </div> */}
        {/* ================= BODY ================= */}
        <div className="crosstab-body">
          {/* ================= FOOTER ================= */}
          {showBuilder && (
            <div className="modal-footer">
              {/* <button
                                className="cancel-btn"
                                onClick={() => setShowBuilder(false)}
                            >
                                Hide Crosstab
                            </button> */}

              <button
                className="generate-btn"
                onClick={() => handleTitleClick(selectedTitle)}
              >
                {loading ? "Generating..." : "Generate Crosstab"}
              </button>
            </div>
          )}
          {/* ===== BUILDER AREA ===== */}
          {showBuilder && (
            <div className="crosstab-builder">
              <DragDropContext
                onDragEnd={onDragEnd}
                onDragUpdate={(update) => {
                  const droppableId =
                    update.destination?.droppableId ||
                    update.combine?.droppableId;
                  if (droppableId === "row-box") {
                    document.getElementById("row-box").style.borderColor =
                      "#2563eb";
                    document.getElementById("col-box").style.borderColor =
                      "#cbd5e1";
                  } else if (droppableId === "col-box") {
                    document.getElementById("col-box").style.borderColor =
                      "#10b981";
                    document.getElementById("row-box").style.borderColor =
                      "#cbd5e1";
                  } else {
                    document.getElementById("row-box").style.borderColor =
                      "#cbd5e1";
                    document.getElementById("col-box").style.borderColor =
                      "#cbd5e1";
                  }
                }}
              >
                <div className="crosstab-main">
                  <Droppable droppableId="var-list">
                    {(provided) => (
                      <div
                        className="var-list"
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        <div className="var-header">
                          <span>Available Variables</span>
                          <span>{filteredAvailableVars.length}</span>
                        </div>
                        <input
                          type="text"
                          placeholder="Search variable..."
                          value={searchVar}
                          onChange={(e) => setSearchVar(e.target.value)}
                          className="var-search"
                        />
                        {filteredAvailableVars.map((v, idx) => (
                          <Draggable key={v} draggableId={v} index={idx}>
                            {(prov, snapshot) => (
                              <div
                                className="var-item"
                                ref={prov.innerRef}
                                {...prov.draggableProps}
                                {...prov.dragHandleProps}
                                style={{
                                  ...prov.draggableProps.style,
                                  opacity: snapshot.isDragging ? 0.5 : 1,
                                }}
                              >
                                {v}
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>

                  <div className="drop-container">
                    <Droppable droppableId="row-box" isCombineEnabled>
                      {(provided) => (
                        <div
                          className="drop-box"
                          id="row-box"
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          <div className="drop-title">
                            <FaTable /> Row Variables
                          </div>
                          {rowVars.length > 0 ? (
                            renderTree(rowVars, removeRowVar, "row-box")
                          ) : (
                            <p className="placeholder">Drag variables here…</p>
                          )}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>

                    <Droppable droppableId="col-box" isCombineEnabled>
                      {(provided) => (
                        <div
                          className="drop-box"
                          id="col-box"
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          <div className="drop-title">
                            <FaTable /> Column Variables
                          </div>
                          {colVars.length > 0 ? (
                            renderTree(colVars, removeColVar, "col-box")
                          ) : (
                            <p className="placeholder">Drag variables here…</p>
                          )}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </div>
                </div>
              </DragDropContext>
              {/* ===== RESULT AREA ===== */}
              <div className="crosstab-result">
                <TabComp
                  isCrossTab={false}
                  frequencyData={frequencyData}
                  displayMode={"table"}
                  displaySettings={{ showFrequency: true, showPercent: true }}
                  crosstabDisplayData={crosstabDisplayData}
                />
              </div>
            </div>
          )}
          {confirmNest && (
            <div className="confirm-overlay">
              <div className="confirm-box">
                <p>
                  Do you want to <strong>nest</strong> "{confirmNest.childId}"
                  under "{confirmNest.parentId}"?
                </p>
                <div className="confirm-buttons">
                  <button onClick={() => handleConfirm("nest")}>Nest</button>
                  <button onClick={() => handleConfirm("add")}>
                    Add Another
                  </button>
                  <button onClick={() => setConfirmNest(null)}>Cancel</button>
                </div>
              </div>
            </div>
          )}

          {/* <button className="cancel-btn" onClick={() => handleTitleClick(selectedTitle)}>RUN</button> */}
        </div>
      </div>
      {JSON.stringify(rowVars)}
    </div>
  );
}
